<template>
  <div v-if="produits.length > 0">
    <div>
      <div class="columns is-marginless is-paddingless">
        <div class="label column is-8 pdb-0 has-text-black">
          {{ $t('reseauTempo.produit') }}
        </div>
        <div class="label column is-4 pdb-0 has-text-black has-text-right">
          {{ $t('reseauTempo.montant') }}
        </div>
      </div>
    </div>
    <div class="is-max-height-130px overflow-y-auto">
      <div class="columns is-multiline is-marginless is-paddingless
        has-background-table-second-color mgb-5px pdb-10px"
          v-for="(produit, index) in produits" :key="index">
        <div class="column is-12">
          <div class="columns">
            <div class="column is-8">
              <p>{{ produit.produitEnfant.libelle }}</p>
            </div>
            <div class="column is-4 has-text-right">
              <p>{{produit.prixUnitaire | formatDevise}}</p>
            </div>
          </div>
        </div>
        <template v-if="produit.liaisonsTarif.length > 0">
          <div v-for="(produitEnfant, index) in produit.liaisonsTarif"
            :key="'child_' + index"
            class="column is-12 is-marginless pdv-0">
            <div class="columns">
              <div class="column is-6 is-offset-2">
                {{ produitEnfant.produitEnfant.libelle}}
              </div>
              <div class="column is-4 has-text-right">
                <p v-if="produitEnfant.prixUnitaire">
                  {{produitEnfant.prixUnitaire | formatDevise}}
                </p>
                <p v-else>{{$t('reseauTempo.nc')}}</p>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    produits: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style>

</style>
